import React from 'react';
import PropTypes from 'prop-types';

import Togglable from '../togglable';

const LikeIcon = Togglable(({ liked }) => (
	<i aria-hidden="true" className="material-icons mr-2">
		{liked?"favorite":"favorite_outline"}
	</i>
))

const LoadingIcon = Togglable(() => (
	<i aria-hidden="true" className="material-icons mr-2">more_horiz</i>
))

const EditableLike = ({ liked, likes, loaded, toggleLiked }) => (
	<button className="btn unsw-mw-0" type="button" onClick={()=>toggleLiked()}>
		<LikeIcon visible={loaded} liked={liked} />
		<LoadingIcon visible={!loaded} />
		Like
		&nbsp;
		<span className="text-black-secondary">&middot;&nbsp;{likes}</span>
	</button>
)

const ReadOnlyLike = ({ likes, loaded }) => (
	<span className="text-black-secondary">Likes: {likes}</span>
)

const Likes = Togglable(({ liked, likes, allow_like, loaded, toggleLiked }) => (
	allow_like
		? <EditableLike liked={liked} likes={likes} loaded={loaded} toggleLiked={toggleLiked} />
		: <ReadOnlyLike likes={likes} loaded={loaded} />
))

export default Likes;